import { useState } from "react"
import PropTypes from "prop-types"
import Icon from "components/planning_center_icon"

const TransactionDropdown = ({ title, totalText, totalAmount, transactions }) => {
  const [showDetails, setShowDetails] = useState(null)

  return (
    <div className="dropdown summary-dropdown">
      <div className="d-f jc-sb d-f@print jc-sb@print mt-1@print">
        <div>
          <button
            style={{
              paddingBottom: "8px",
              fontSize: "16px",
              display: "inline-block",
              cursor: "pointer"
            }}
            onClick={() => setShowDetails(!showDetails)}
          >
            <span>{title}</span>
            <span className="c-neutral-400 font-size-5 pl-4p p-r t-1p">
              <Icon symbol="general#down-chevron" />
            </span>
          </button>
        </div>
        <div className="d-f">{!showDetails && totalAmount}</div>
      </div>
      <div
        className="mb-2"
        style={{ fontSize: "0.875rem", color: "var(--t-fill-color-neutral-020)" }}
      >
        {showDetails &&
          transactions.map(transaction => (
            <dl key={transaction.id} className="summary-transaction flexed-items-with-ellipsis">
              <dt className="flexed-item">
                <button data-modal-url={transaction.paths.show} className="link">
                  {transaction.shortDescription}
                  {transaction.note && (
                    <span
                      className="ml-4p p-r t-2p font-size-4 c-neutral-600"
                      data-tooltip={transaction.note}
                      data-tooltip-location="right"
                    >
                      <Icon
                        symbol="general#outlined-dots"
                        aria-label="This transaction has an associated note."
                      />
                    </span>
                  )}
                </button>
              </dt>
              <dd className="flexed-item">
                <button data-modal-url={transaction.paths.show} className="link">
                  {transaction.amount}
                </button>
              </dd>
            </dl>
          ))}
        {showDetails && transactions.length > 1 && (
          <dl className="summary-transaction flexed-items-with-ellipsis fw-600">
            <dt className="flexed-item">{totalText}</dt>
            <dd className="flexed-item">{totalAmount}</dd>
          </dl>
        )}
      </div>
    </div>
  )
}

TransactionDropdown.propTypes = {
  title: PropTypes.string,
  totalText: PropTypes.string,
  totalAmount: PropTypes.string,
  transactions: PropTypes.array
}

export default TransactionDropdown
